import React, { useState, useEffect } from 'react';
import PageWrapper from '../componenti/PageWrapper';
import PageContent from '../componenti/PageContent';
import { AlbumContent as PaginaAlbumLibreria } from 'react-gallery-albums';
import { CircularProgress, Box, Typography } from '@mui/material';
import { API_BASE_URL, UPLOADS_BASE_URL } from '../context/AuthContext';

export default function AlbumContent() {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlbums = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/albums.php`);
        const data = await response.json();
        if(Array.isArray(data)) {
          const formatted = data.map(album => ({
            title: album.title,
            images: album.images ? album.images.map(img => `${UPLOADS_BASE_URL}/${img.image_url}`) : []
          }));
          setAlbums(formatted);
        }
      } catch (error) {
        console.error("Errore fetch albums per contenuto:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAlbums();
  }, []);

  return (
    <PageWrapper>
      <PageContent title="Galleria">
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : albums.length === 0 ? (
          <Typography align="center" sx={{ mt: 4 }}>Album non trovato o vuoto.</Typography>
        ) : (
          <PaginaAlbumLibreria albums={albums} galleryPath="/galleria" />
        )}
      </PageContent>
    </PageWrapper>
  );
}